import { ConfirmationModal, AlertBanner } from "@qubit/autoparts";
import { useTranslation } from "react-i18next";

import { useConfigurePortsWithRetry } from "~/hooks/useConfigurePortsWithRetry";

type PickBatchModalProps = { pickBatch: () => void; closeModal: () => void };

export const PickBatchModal = ({
  pickBatch,
  closeModal
}: PickBatchModalProps) => {
  const { t } = useTranslation();

  const {
    configurePortsWithRetry: configurePortsWithRetry,
    isConfigurePortsRetrying: isConfigurePortsRetrying
  } = useConfigurePortsWithRetry({
    workstationMode: "Picking"
  });

  const modalBody = (
    <>
      <p>{t("you are about to be redirected to picking")}</p>
      {isConfigurePortsRetrying && (
        <AlertBanner severity="info" sx={{ my: 2 }}>
          {t("please wait switching workstation mode")}
        </AlertBanner>
      )}
    </>
  );

  const handleConfirm = async () => {
    const configurePortsSuccess = await configurePortsWithRetry();
    if (!configurePortsSuccess) {
      return;
    }

    closeModal();
    pickBatch();
  };

  const handleClose = () => {
    if (!isConfigurePortsRetrying) {
      closeModal();
    }
  };

  return (
    <ConfirmationModal
      isOpen={true}
      confirmCb={handleConfirm}
      closeCb={handleClose}
      modalTitle={t("ready to start picking")}
      modalText={modalBody}
      labelledById="pick-batch-modal-title"
      isConfirmLoading={isConfigurePortsRetrying}
      isCanceledDisabled={isConfigurePortsRetrying}
      disableEscapeKeyDown={isConfigurePortsRetrying}
    />
  );
};
